<label [for]="name" class="skf-label" [class.blank-mode]="blankMode">{{label|uppercase}}</label>
